import styled from "styled-components";

export const ButtonPrimary = styled.button`
  display: inline-block;
  padding: 12px 30px;
  border: 0px;
  background-color: #066fef;
  color: #ffffff;
  outline: 0;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  border-radius: 25px;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #1700f4;
  }
`;
